// Моковые данные для таблицы зарплаты
export const getMockSalaryData = (selectedMonth) => {
  // Генерируем дату отправки (например, последний день месяца)
  const submissionDate = new Date(
    selectedMonth.getFullYear(),
    selectedMonth.getMonth() + 1,
    0
  );

  return [
    {
      id: 1,
      name: "Конструкторский отдел",
      initiator: "Аскарова Ж.",
      approvers: [
        {
          role: "Директор",
          name: "Бекбауов С.",
          status: "На рассмотрении",
        },
        {
          role: "Финансовый руководитель",
          name: "Тлебаева Б.",
          status: "На рассмотрении",
        },
        {
          role: "Руководитель отдела",
          name: "Казиев Б.",
          status: "На рассмотрении",
        },
      ],
      submissionDate: submissionDate,
    },
    {
      id: 2,
      name: "Отдел управления проектами ОЗ",
      initiator: "Аскарова Ж.",
      approvers: [
        {
          role: "Директор",
          name: "Бекбауов С.",
          status: "На рассмотрении",
        },
        {
          role: "Финансовый руководитель",
          name: "Тлебаева Б.",
          status: "Согласован",
        },
        {
          role: "Руководитель отдела",
          name: "Иванов А.",
          status: "На рассмотрении",
        },
      ],
      submissionDate: submissionDate,
    },
    {
      id: 3,
      name: "Архитектурный отдел МЖК",
      initiator: "Аскарова Ж.",
      approvers: [
        {
          role: "Директор",
          name: "Бекбауов С.",
          status: "Согласован",
        },
        {
          role: "Финансовый руководитель",
          name: "Тлебаева Б.",
          status: "Согласован",
        },
        {
          role: "Руководитель отдела",
          name: "Петров В.",
          status: "Согласован",
        },
      ],
      submissionDate: submissionDate,
    },
    {
      id: 4,
      name: "Архитектурный отдел МЖК",
      initiator: "Аскарова Ж.",
      approvers: [
        {
          role: "Директор",
          name: "Бекбауов С.",
          status: "Согласован",
        },
        {
          role: "Финансовый руководитель",
          name: "Тлебаева Б.",
          status: "Отклонено",
          comment: "Необходимо пересмотреть суммы по командировкам. Превышен лимит на командировочные расходы.",
        },
        {
          role: "Руководитель отдела",
          name: "Петров В.",
          status: "Согласован",
        },
      ],
      submissionDate: submissionDate,
    },
    {
      id: 5,
      name: "Отдел разработки",
      initiator: null, // Не отправляли на согласование
      approvers: [], // Нет статусов
      submissionDate: null,
    },
    {
      id: 6,
      name: "Отдел маркетинга",
      initiator: "Аскарова Ж.",
      approvers: [
        {
          role: "Директор",
          name: "Бекбауов С.",
          status: "Согласован",
        },
        {
          role: "Финансовый руководитель",
          name: "Тлебаева Б.",
          status: "Согласован",
        },
        {
          role: "Руководитель отдела",
          name: "Козлова Е.",
          status: "На рассмотрении",
        },
      ],
      submissionDate: submissionDate,
    },
    {
      id: 7,
      name: "HR отдел",
      initiator: null, // Не отправляли на согласование
      approvers: [], // Нет статусов
      submissionDate: null,
    },
    {
      id: 8,
      name: "Бухгалтерия",
      initiator: "Аскарова Ж.",
      approvers: [
        {
          role: "Директор",
          name: "Бекбауов С.",
          status: "Согласован",
        },
        {
          role: "Финансовый руководитель",
          name: "Тлебаева Б.",
          status: "Согласован",
        },
        {
          role: "Руководитель отдела",
          name: "Новикова О.",
          status: "Согласован",
        },
      ],
      submissionDate: submissionDate,
    },
    {
      id: 9,
      name: "Отдел продаж",
      initiator: null, // Еще не отправляли на согласование
      approvers: [], // Нет статусов
      submissionDate: null,
    },
    {
      id: 10,
      name: "Отдел качества",
      initiator: null, // Еще не отправляли на согласование
      approvers: [], // Нет статусов
      submissionDate: null,
    },
    {
      id: 11,
      name: "Юридический отдел",
      initiator: null, // Еще не отправляли на согласование
      approvers: [], // Нет статусов
      submissionDate: null,
    },
    {
      id: 12,
      name: "IT отдел",
      initiator: null, // Еще не отправляли на согласование
      approvers: [], // Нет статусов
      submissionDate: null,
    },
  ];
};

